<template lang="pug">
  .profile-page-form
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Контакты
      .profile-section__body
        .form
          .form__group(
          v-for="contact in fields.contacts"
          )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title ФИО
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="contact.fio"
                  )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Должность
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="contact.present_post"
                  )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Телефон
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="contact.extra"
                  )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddItem"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Социальные сети
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Vk
              .form-elem__body
                input.input.input_full(
                maxlength="256"
                v-model="fields.vkontakte"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Instagram
              .form-elem__body
                input.input.input_full(
                maxlength="256"
                v-model="fields.instagram"
                )

    section.profile-page-form__section.profile-section
      .profile-section__body
        .form
          .form__elem.form__elem_button
            .form-elem(
            v-if="campData"
            )
              .form-elem__body
                router-link.button.button_long(
                :to="{name: 'CurrentCamp', params: {campId: campData.id}}"
                target="_blank"
                )
                  .button__text Просмотр
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_long(
                @click.prevent="onSaveCamp"
                )
                  .button__text Сохранить
</template>

<script>

export default {
  name: "ManagerCampEditorContacts",
  props: {
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fields: {
        contacts: [
          {
            fio: "",
            present_post: "",
            extra: ""
          }
        ],
        vkontakte: "",
        instagram: ""
      }
    };
  },
  methods: {
    setFields(campData) {
      if (campData.contacts.length > 0) {
        this.fields.contacts = campData.contacts;
      }
      this.fields.instagram = campData.instagram;
      this.fields.vkontakte = campData.vkontakte;
    },
    onAddItem() {
      this.fields.contacts.push({
        fio: "",
        present_post: "",
        extra: ""
      });
    },
    onSaveCamp() {
      const contacts = this.fields.contacts.filter(item => {
        if (item.fio.length > 0 || item.present_post.length > 0 || item.extra.length > 0) {
          return item;
        }
      });
      if (contacts.length === 0) {
        this.fields.contacts = [
          {
            fio: "",
            present_post: "",
            extra: ""
          }
        ];
      } else {
        this.fields.contacts = contacts;
      }
      const data = {
        contacts: contacts,
        vkontakte: this.fields.vkontakte,
        instagram: this.fields.instagram
      };
      this.$emit("on-save-camp", data);
    }
  },
  watch: {
    campData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.campData) {
      this.setFields(this.campData);
    }
  }

};
</script>
